import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function ContactUsPage() {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    width: '90%',
                    maxWidth: '800px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    mt: 6,
                }}
            >
                <Typography variant="h4" sx={{ mb: 3 }}>
                    Contact Us
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                    <strong>Email:</strong> admin@zipzyride.com
                </Typography>

                <Typography variant="body1">
                    <strong>Address:</strong>
                    <br />
                    FLAT NO 303 BLOCK A, RENAISSANCE PARK 3,
                    <br />
                    Bengaluru North, Bengaluru,
                    <br />
                    Karnataka, India, 560055
                </Typography>

                <br />
                <br />
                <br />
                <br />
                <br />
            </Box>
        </Box>
    );
}
